import React from 'react';
import styled from 'styled-components';
import { Row, Col, Space } from 'antd';
import { FormattedMessage, defineMessage, useIntl } from 'react-intl';

import ActionsButton from 'Common/Components/ActionButton';

const Title = styled.h3`
  margin: 0;
  line-height: 2em;
`;

const BEST_SELLERS_REPORT = 'BEST_SELLERS_REPORT';
const TRANSACTIONS_REPORT = 'TRANSACTIONS_REPORT';
const exportReportActions = [
  {
    id: 1,
    action: BEST_SELLERS_REPORT,
    label: defineMessage({
      defaultMessage: 'Bestseller Report',
    }),
  },
  {
    id: 2,
    action: TRANSACTIONS_REPORT,
    label: defineMessage({
      defaultMessage: 'Transactions Report',
    }),
  },
];

interface Props {
  openModal: (action: string) => void;
}
const RevenueOverviewHeader: React.FC<Props> = ({ openModal }) => {
  const intl = useIntl();

  const exportReportOptions = exportReportActions.map((o) => ({
    ...o,
    label: intl.formatMessage(o.label),
  }));

  return (
    <Row css="padding: 1em 1.2em">
      <Col span={8}>
        <Title>
          <FormattedMessage defaultMessage="Revenue Overview" />
        </Title>
      </Col>
      <Col span={16} css=" display: flex; justify-content: flex-end;">
        <Space size="middle">
          <ActionsButton
            createButtonLabel={intl.formatMessage({
              defaultMessage: 'Export',
            })}
            createButtonType="default"
            actionType="outbound"
            actionOptions={exportReportOptions}
            selectedItems={exportReportOptions.map((p) => p.id)}
            css="margin-left: 10px"
            handleClick={(action) => {
              if (action) openModal(action);
            }}
          />
        </Space>
      </Col>
    </Row>
  );
};

export default RevenueOverviewHeader;
